import { FC, LazyExoticComponent, lazy, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { cookieStore } from '../../utils/polyfills/cookie-store';

import { checkIfDocumentIsLoaded } from '../../utils/hoc/checkIfDocumentIsLoaded'
import { addGoogleAnalytics, configureGoogleAnalytics, initGoogleAnalytics } from './googleAnalyticsConfig';
import { addTrustPilot, initTrustPilot } from './trustPilotConfig';
import { CookieNoticeProps } from '@mirzalikic/react-cookie-notice';
import { TrustPilotContext } from '../../utils/ctx/TrustPilotContext';
import { disableComponentInDev } from '../../utils/hoc/disableComponentInDev';

const WP21CookieNotice = disableComponentInDev(checkIfDocumentIsLoaded(() => {
  const { t } = useTranslation();
  const [CookieNotice, setCookieNotice] = useState<LazyExoticComponent<FC<CookieNoticeProps>> | null>(null);
  const { setIsTrustPilotLoaded } = useContext(TrustPilotContext);

  // useEffect(() => {
  // 03.04.24 - don't load cookie notice
  // setCookieNotice(lazy(() => import('@mirzalikic/react-cookie-notice')));
  // }, [])

  useEffect(() => {
    setTimeout(() => {
      cookieStore.set('wp21marketing', 'true');
      cookieStore.set('wp21essential', 'true');

      initGoogleAnalytics();
      initTrustPilot(setIsTrustPilotLoaded);
    }, 1000);
  })

  if (!CookieNotice) {
    return null;
  }

  return (
    <CookieNotice
      onSave={(cookies) => {
        const marketingCookies = cookies.filter((cookie) => cookie.name === 'marketing')[0]
        const essentialCookies = cookies.filter((cookie) => cookie.name === 'essential')[0]

        if (marketingCookies.checked) {
          addGoogleAnalytics().then((e) => {
            configureGoogleAnalytics()
          })
        }

        if (essentialCookies.checked) {
          addTrustPilot(setIsTrustPilotLoaded);
        }
      }}
      cookiePrefix="wp21"
      containerClass="react-cookie-notice-container !bg-blue border border-x-0 border-b-0 border-primary"
      contentClass="react-cookie-notice-content !w-full p-4"
      buttonPrimaryClass="react-cookie-notice-button-primary !bg-primary !text-white"
      acceptAllButtonText={t('cookies.accept-all')}
      preferencesButtonText={t('cookies.preferences')}
      cookies={[
        { name: 'essential', checked: true, editable: false, default: true, title: t('cookies.essential.title'), text: t('cookies.essential.description') },
        { name: 'marketing', checked: false, editable: true, title: t('cookies.marketing.title'), text: t('cookies.marketing.description') },
      ]}
    >
      <p>
        {t('cookies.notice')}
      </p>
    </CookieNotice>
  )
}));

export default WP21CookieNotice;
